import React, { useEffect, useState } from 'react';
import { makeStyles, DialogContent, Dialog, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { loadProfileByUserId } from '../../common/services/dashboardServices';

import InterviewDialog from '../../empTalentCenter/subComponents/InterviewDialog';
import SendMessageDialog from '../../empTalentCenter/subComponents/SendMessageDialog';
import JobSeekerProfile from '../../empTalentCenter/subComponents/JobSeekerProfile';
import Logo from '../../system/Logo';

// import _get from 'lodash/get';

const useStyles = makeStyles(theme => ({
    root: {},
    rootDialog: {
        padding: '24px 24px 0 24px !important',
        overflowY: 'hidden',
    },
    closeButton: { margin: '20px 36px 20px 20px' },
    appLogo: { width: 200, cursor: 'pointer' },
    labelContainer: { width: '100%', textAlign: 'left' },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '600',
        textAlign: 'center',
    },
    closeIconButton: {
        width: '20px',
        height: '20px',
    },
}));

const getDefns = params => {
    const { props, classes, jobSeekerData } = params;
    const { open, onClose, jobSeekerApplySavedDt, isSaved, isHideSavedToMyJobs } = props;

    const defns = {
        root: { open, maxWidth: 'lg', fullWidth: true, disableBackdropClick: true, disableEscapeKeyDown: true, fullScreen: true },
        closeButton: { onClick: onClose },
        closeIconButton: { onClick: onClose },
        jobSeekerProfile: {
            jobSeeker: { data: jobSeekerData },
            isInDialog: true,
            jobSeekerApplySavedDt,
            isSaved,
            isHideSavedToMyJobs,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

const ProfileDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    // const appContext = useContext(AppContext);
    // const { employerId } = appContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { profileData, jobSeekerId } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [jobSeekerData, setJobSeekerData] = useState({});
    const [interviewDialogOpen, setInterviewDialogOpen] = useState(false);
    const [sendMessageDialogOpen, setSendMessageDialogOpen] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        if (profileData) {
            setJobSeekerData(profileData);
        } else if (jobSeekerId) {
            loadProfileByUserId(jobSeekerId, setJobSeekerData);
        }
    }, [jobSeekerId, profileData]);

    //---------------------------------------------------------------------
    // derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Event handlers
    //---------------------------------------------------------------------
    const handleSaveToJobs = () => {
        console.log('handleSaveToJobs');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        jobSeekerData,
        interviewDialogOpen,
        setInterviewDialogOpen,
        setSendMessageDialogOpen,
        handleSaveToJobs,
        sendMessageDialogOpen,
        props,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <>
            <Dialog {...defns.root}>
                <DialogTitle>
                    <div {...defns.titleContainer}>
                        <div {...defns.labelContainer}>
                            <Logo {...defns.appLogo} />
                        </div>
                        <div {...defns.closeIconButtonContainer}>
                            <IconButton {...defns.closeIconButton}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent {...defns.rootDialog}>
                    <JobSeekerProfile {...defns.jobSeekerProfile} />
                </DialogContent>
                {/* <DialogActions>
                    <AfitdButton {...defns.closeButton}>Close</AfitdButton>
                </DialogActions> */}
            </Dialog>
            {interviewDialogOpen && <InterviewDialog {...defns.interviewDialog} />}
            {sendMessageDialogOpen && <SendMessageDialog {...defns.sendMessageDialog} />}
        </>
    );
};

export default ProfileDialog;
